module.exports = __webpack_public_path__ + "img/swift_invoice_login_illustration_no_logo.f285443f.png";